var map = {
	"./layouts/card": 22,
	"./layouts/card/": 22,
	"./layouts/card/index": 22,
	"./layouts/card/index.tsx": 22,
	"./layouts/card/style.module": 157,
	"./layouts/card/style.module.scss": 157,
	"./layouts/components/breadcrumbs": 132,
	"./layouts/components/breadcrumbs/": 132,
	"./layouts/components/breadcrumbs/index": 132,
	"./layouts/components/breadcrumbs/index.tsx": 132,
	"./layouts/components/breadcrumbs/style.module": 192,
	"./layouts/components/breadcrumbs/style.module.scss": 192,
	"./layouts/components/container": 48,
	"./layouts/components/container/": 48,
	"./layouts/components/container/index": 48,
	"./layouts/components/container/index.tsx": 48,
	"./layouts/components/container/style.module": 134,
	"./layouts/components/container/style.module.scss": 134,
	"./layouts/components/footer": 133,
	"./layouts/components/footer/": 133,
	"./layouts/components/footer/index": 133,
	"./layouts/components/footer/index.tsx": 133,
	"./layouts/components/footer/style.module": 92,
	"./layouts/components/footer/style.module.scss": 92,
	"./layouts/components/loading_indicator": 59,
	"./layouts/components/loading_indicator/": 59,
	"./layouts/components/loading_indicator/index": 59,
	"./layouts/components/loading_indicator/index.tsx": 59,
	"./layouts/components/nav_bar": 103,
	"./layouts/components/nav_bar/": 103,
	"./layouts/components/nav_bar/index": 103,
	"./layouts/components/nav_bar/index.tsx": 103,
	"./layouts/components/nav_bar/standalone": 360,
	"./layouts/components/nav_bar/standalone.tsx": 360,
	"./layouts/components/nav_bar/style.module": 35,
	"./layouts/components/nav_bar/style.module.scss": 35,
	"./layouts/components/notice_banner": 90,
	"./layouts/components/notice_banner/": 90,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 193,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 193,
	"./layouts/components/notice_banner/index": 90,
	"./layouts/components/notice_banner/index.tsx": 90,
	"./layouts/components/notice_banner/standalone": 361,
	"./layouts/components/notice_banner/standalone.tsx": 361,
	"./layouts/components/notice_banner/style.module": 194,
	"./layouts/components/notice_banner/style.module.scss": 194,
	"./layouts/page": 107,
	"./layouts/page/": 107,
	"./layouts/page/index": 107,
	"./layouts/page/index.tsx": 107,
	"./layouts/page/style.module": 93,
	"./layouts/page/style.module.scss": 93,
	"./layouts/types": 362,
	"./layouts/types.ts": 362,
	"./marketing/pages/home/toefl": 1568,
	"./marketing/pages/home/toefl/": 1568,
	"./marketing/pages/home/toefl/index": 1568,
	"./marketing/pages/home/toefl/index.tsx": 1568,
	"./marketing/pages/home/toefl/sections/ai": 1169,
	"./marketing/pages/home/toefl/sections/ai/": 1169,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature": 1801,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature.png": 1801,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature": 1802,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature.png": 1802,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature": 1803,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature.png": 1803,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature": 1804,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature.png": 1804,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg": 1805,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg.svg": 1805,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon": 1806,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon.svg": 1806,
	"./marketing/pages/home/toefl/sections/ai/index": 1169,
	"./marketing/pages/home/toefl/sections/ai/index.tsx": 1169,
	"./marketing/pages/home/toefl/sections/ai/style.module": 1807,
	"./marketing/pages/home/toefl/sections/ai/style.module.scss": 1807,
	"./marketing/pages/home/toefl/sections/apps": 1170,
	"./marketing/pages/home/toefl/sections/apps/": 1170,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon": 1808,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon.svg": 1808,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon": 1809,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon.svg": 1809,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app": 1810,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app.png": 1810,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon": 1811,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon.svg": 1811,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app": 1812,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app.png": 1812,
	"./marketing/pages/home/toefl/sections/apps/index": 1170,
	"./marketing/pages/home/toefl/sections/apps/index.tsx": 1170,
	"./marketing/pages/home/toefl/sections/features": 1171,
	"./marketing/pages/home/toefl/sections/features/": 1171,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature": 1813,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature.png": 1813,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature": 1814,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature.png": 1814,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature": 1815,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature.png": 1815,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon": 1816,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon.svg": 1816,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature": 1817,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature.png": 1817,
	"./marketing/pages/home/toefl/sections/features/index": 1171,
	"./marketing/pages/home/toefl/sections/features/index.tsx": 1171,
	"./marketing/pages/home/toefl/sections/official_questions": 1175,
	"./marketing/pages/home/toefl/sections/official_questions/": 1175,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen": 1826,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen.png": 1826,
	"./marketing/pages/home/toefl/sections/official_questions/index": 1175,
	"./marketing/pages/home/toefl/sections/official_questions/index.tsx": 1175,
	"./marketing/pages/home/toefl/sections/official_questions/style.module": 688,
	"./marketing/pages/home/toefl/sections/official_questions/style.module.scss": 688,
	"./marketing/pages/home/toefl/sections/value_props": 1172,
	"./marketing/pages/home/toefl/sections/value_props/": 1172,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles": 1818,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles.svg": 1818,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon": 1819,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon.svg": 1819,
	"./marketing/pages/home/toefl/sections/value_props/index": 1172,
	"./marketing/pages/home/toefl/sections/value_props/index.tsx": 1172,
	"./marketing/pages/home/toefl/sections/value_props/style.module": 2216,
	"./marketing/pages/home/toefl/sections/value_props/style.module.scss": 2216,
	"./marketing/pages/home/toefl/sections/video_based_learning": 1173,
	"./marketing/pages/home/toefl/sections/video_based_learning/": 1173,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card": 1820,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card.png": 1820,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg": 1821,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg.png": 1821,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot": 1822,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot.png": 1822,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon": 1823,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon.svg": 1823,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail": 1824,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail.png": 1824,
	"./marketing/pages/home/toefl/sections/video_based_learning/index": 1173,
	"./marketing/pages/home/toefl/sections/video_based_learning/index.tsx": 1173,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module": 687,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module.scss": 687,
	"./marketing/pages/home/toefl/sections/wall_of_love": 1174,
	"./marketing/pages/home/toefl/sections/wall_of_love/": 1174,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot": 1825,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot.png": 1825,
	"./marketing/pages/home/toefl/sections/wall_of_love/index": 1174,
	"./marketing/pages/home/toefl/sections/wall_of_love/index.tsx": 1174,
	"./marketing/pages/home/toefl/style.module": 1827,
	"./marketing/pages/home/toefl/style.module.scss": 1827,
	"./marketing/pages/plans/toefl": 1569,
	"./marketing/pages/plans/toefl/": 1569,
	"./marketing/pages/plans/toefl/index": 1569,
	"./marketing/pages/plans/toefl/index.tsx": 1569,
	"./marketing/pages/plans/toefl/sections/testimonials": 1176,
	"./marketing/pages/plans/toefl/sections/testimonials/": 1176,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot": 1828,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot.png": 1828,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot": 1829,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot.png": 1829,
	"./marketing/pages/plans/toefl/sections/testimonials/index": 1176,
	"./marketing/pages/plans/toefl/sections/testimonials/index.tsx": 1176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2554;